import { Component, OnInit, AfterViewInit, DoCheck } from '@angular/core';
import { Compiler, NgModule, ViewChild, ViewContainerRef, Injectable } from '@angular/core';
import { Item } from '../../model/item';
import { Answer } from '../../model/answer';
import { CONFIG } from '../../constants/constants';
import { ItemService } from '../item/item.service';
import { AnswerService } from '../answer/answer.service';
import { RestService } from '../rest/rest.service';
import { AnswerControlService } from '../answer/answerControl.service';
import { WelcomeService } from "../../services/welcome/welcome.service";
import { ItemControlService } from "../item/item-control.service";
import { StateService } from "../../services/state/state.service";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TokenControlService } from "../state/tokenControl.service";
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { TimeChrono } from "../../model/timeChrono";
import { ConfigurationControlService } from "../../services/configuration/configurationControl.service";
import { CodResp } from '../../constants/codigosMensajes';
import { DateServerService } from '../dateServerService/date-server.service';
import { FileAnswer } from '../../model/FileAnswer';

//Variable del global scope para funcionamiento de MathJax
declare var MathJax: any;

//Variable del global scope para utilizar jquery
declare var $: any;

declare var ClassicEditor: any;

/*Servicio de respuestas*/
@Injectable({
  providedIn: 'root'
})

export class AddComponentService {

  /** Flag para manejo de contraste */
  public contrast: Boolean;

  //Inyeccion del componente interno que compilara el html de los items
  /* @ViewChild('container', { read: ViewContainerRef })
   container: ViewContainerRef;*/

  public inputFileJquery: any = null;

  public components: Map<any, any> | null = null;

  constructor(private _compiler: Compiler, private _configurationControlService: ConfigurationControlService,
    private _welcomeDataService: WelcomeService, public _itemControlService: ItemControlService,
    private _dateServerService: DateServerService) {
    this.contrast = false;
  }

  // ✅ AGREGAR ESTA FUNCIÓN AQUÍ (después del constructor)
  /**
   * Sanitiza el template para corregir errores comunes en atributos de formularios
   */
  public sanitizeTemplate(template: string): string {
    console.log('==================== TEMPLATE COMPLETO ====================');
    console.log('Longitud total:', template.length);

    // ✅ BUSCAR EL COMPONENTE PROBLEMÁTICO
    if (template.includes('quickNotes')) {
      console.log('🔍 ENCONTRADO quickNotes en template');
      const quickNotesContext = template.match(/.{0,100}quickNotes.{0,100}/gi);
      if (quickNotesContext) {
        console.log('📝 Contexto de quickNotes:', quickNotesContext);
      }
    }

    try {
      // ✅ 1. Reemplazar ck-editor por textarea
      const ckEditorReplaced = template.match(/<ck-editor/gi);
      if (ckEditorReplaced) {
        template = template.replace(
          /<ck-editor\s+\[\(ngModel\)\]="([^"]+)"\s+name="([^"]+)"\s+language="([^"]+)"[^>]*>\s*<\/ck-editor>/gi,
          `<textarea [(ngModel)]="$1" name="$2" rows="10" maxlength="2000" class="form-control open-answer-textarea" placeholder="Escribe tu respuesta aquí (Mínimo 200 caracteres, Máximo 2000 caracteres)" (input)="updateCharCount($event)"></textarea>
          <div class="char-counter text-right">
            <small id="charCountContainer" class="text-warning">
              <span id="charCount">0</span> / 2000 caracteres
              <span style="margin-left: 10px; font-size: 11px;">(Mínimo: 200)</span>
            </small>
          </div>`
        );
        console.log('✅ CKEditor reemplazado por textarea');
      }

      // ✅ 2. Buscar y reemplazar quick-notes (o cualquier otro componente personalizado)
      const quickNotesPattern = /<quick-notes\s+\[\(ngModel\)\]="([^"]+)"\s+name="([^"]+)"[^>]*>\s*<\/quick-notes>/gi;
      if (template.match(quickNotesPattern)) {
        template = template.replace(
          quickNotesPattern,
          '<textarea [(ngModel)]="$1" name="$2" rows="5" class="form-control quick-notes-textarea" placeholder="Notas rápidas..."></textarea>'
        );
        console.log('✅ quick-notes reemplazado por textarea');
      }

      // ✅ 3. Reemplazar CUALQUIER componente personalizado con ngModel que no sea estándar
      // Buscar patrones como: <custom-component [(ngModel)]="..." name="..."></custom-component>
      const customComponentPattern = /<([a-z]+-[a-z-]+)\s+\[\(ngModel\)\]="([^"]+)"\s+name="([^"]+)"[^>]*>\s*<\/\1>/gi;
      template = template.replace(customComponentPattern, (match, tagName, ngModel, name) => {
        // Excluir elementos HTML estándar y componentes conocidos
        const standardElements = ['text-area', 'input-text', 'select-option'];
        if (!standardElements.includes(tagName)) {
          console.log(`⚠️ Reemplazando componente personalizado: <${tagName}> por textarea`);
          return `<textarea [(ngModel)]="${ngModel}" name="${name}" rows="5" class="form-control custom-component-${tagName}" placeholder="Escribe aquí..."></textarea>`;
        }
        return match; // Dejar sin cambios si es un elemento estándar
      });

      // ✅ 4. Limpiar entidades HTML (&quot;) si existen
      template = template.replace(/name=(["'])&quot;([^&]+)&quot;\1/gi, 'name="$2"');
      template = template.replace(/language=(["'])&quot;([^&]+)&quot;\1/gi, 'language="$2"');

      console.log('✅ Template sanitizado completamente');

    } catch (e) {
      console.error('❌ Error sanitizando template:', e);
    }

    return template;
  }

  public templateAjusteLectorPantallaHtml(template) {
    try {
      /*template = template.split("(click)='selectAnswer($event)'")
      .join("(change)='selectAnswer($event)'");

      template = template.split(`(click)="selectAnswer($event)"`)
      .join("(change)='selectAnswer($event)'");*/

      template = template.split("tabindex=")
        .join("data-index=");

      template = template.split("alt=")
        .join("tabindex='0' alt=");

    } catch (e) {
      console.error("Error templateAjusteLectorPantallaHtml")
    }
    //modificacion leer imagenes en radios
    template = this.htmlQuitarLabelRadio(template, "<label class='radio' >");
    template = this.htmlQuitarLabelRadio(template, '<label class="radio" >');

    return template;
  }


  private htmlQuitarLabelRadio(template, labelString: string) {
    try {
      const listaLabel = template.split(labelString);
      var html = "";
      if (listaLabel.length > 1) {
        for (var i = 0; i < listaLabel.length; i++) {
          let htmlParte = listaLabel[i];
          if (i != 0) {
            htmlParte = `<div class='radio'>${htmlParte.replace("</label>", "</div>")}`;
          }
          html += htmlParte;
        }
      } else {
        html = template;
      }
    } catch (e) {
      console.error("Error templateAjusteLectorPantallaHtml", e)
      return template;
    }

    return html;
  }

  public addComponent(template: string, container: ViewContainerRef, itemNumero: string, _parent: any): string {
    // ✅ Inicializamos this.components si no existe
    if (!this.components) {
      this.components = new Map();
    }
    this.components.clear();

    // ✅ Verificamos que container exista antes de limpiar
    if (container) {
      container.clear();
    }

    // ✅ AGREGAR ESTA LÍNEA AQUÍ - Sanitizar ANTES de ajustar para lector de pantalla
    template = this.sanitizeTemplate(template);

    template = this.templateAjusteLectorPantallaHtml(template);
    @Component({ template: template })
    class TemplateComponent implements AfterViewInit, DoCheck {

      /*almacena la respuesta de preguntas de opcion multiple
      con unica respuesta */
      public respAng: any;

      public editorContent: string;

      /*almacena las respuestas de preguntas de tipo grilla*/
      public respsAng: any[];

      //constante que contiene la url base de los recursos (imagenes, videos)
      public rutaBase: string = CONFIG.RUTA_BASE;

      /*almacena las respuestas de preguntas de tipo grilla
      en un array de tipo Answer*/
      private gridAnswers: Answer[];

      /*Array para construccion de la cadena de respuesta
      para preguntas tipo grilla*/
      private gridAnswerChain: string[];

      private sizeItem: number;



      realoadAudio = (event: any, cantidadRespuestas: number) => {
        this._itemControlService.subItem.next({ id: event.currentTarget.name, cantidadRespuestas: cantidadRespuestas });
      }

      ngDoCheck(): void {
        !(this._welcomeDataService.data.discapacidad && this._configurationControlService.habilitarAudio) ? this.ocultarBotonSubItemAudio() : this.mostrarBotonSubItemAudio();
      }

      constructor(public _answerController: AnswerControlService,
        private _tokenController: TokenControlService,
        private _answerService: AnswerService,
        private _restService: RestService,
        private _itemService: ItemService,
        private _welcomeDataService: WelcomeService,
        public _itemControlService: ItemControlService,
        private _stateService: StateService,
        private _configurationControlService: ConfigurationControlService,
        private _dateServerService: DateServerService) {
        window.clearInterval(this._answerController.testChrono);
        this.respsAng = [];
        this.gridAnswers = [];
        this.gridAnswerChain = [];

        if (this._answerController.itemType == 'grid') {
          if (this._answerController.respuesta) {
            this.respsAng = this._answerController.respuesta.split('|');
            let rtaGrid = "";
            for (let i = 0; i < this.respsAng.length; i++) {
              this.gridAnswers[i] = new Answer(0, 0, this._dateServerService.getDateServer(), this.respsAng[i], 'N', 0, 0, '', '', 0);
              this.gridAnswerChain[i] = this.respsAng[i];
              rtaGrid += this.respsAng[i];
              rtaGrid += '|';
            }
            this._answerController.listenFromGrid(rtaGrid.substring(0, rtaGrid.lastIndexOf('|')));
          } else {
            this._itemService.getItem(this._answerController.itemId).then(res => {
              this.sizeItem = res.itemChild;
              this.respsAng = [];
              let rtaGrid = "";
              for (let i = 0; i < this.sizeItem; i++) {
                this.respsAng.push('O');
                this.gridAnswerChain[i] = 'O';
                rtaGrid += 'O';
                rtaGrid += '|';
              }
              this._answerController.listenFromGrid(rtaGrid.substring(0, rtaGrid.lastIndexOf('|')));
            });

          }
        } else if (this._answerController.itemType == 'ing_p2' || this._answerController.itemType == 'ing_p4' || this._answerController.itemType == 'ing_p7') {
          if (this._answerController.respuesta) {
            this.respsAng = this._answerController.respuesta.split('|');

            for (let i = 0; i < this.respsAng.length; i++) {
              this.gridAnswers[i] = new Answer(0, 0, this._dateServerService.getDateServer(), '', 'N', 0, 0, '', '', 0);
              this.gridAnswerChain[i] = this.respsAng[i];
            }

          } else {
            if (this._itemControlService.item == null) {
              this._itemService.getItem(this._answerController.itemId).then(
                (res: Item) => {
                  this.sizeItem = res.itemChild;
                  this.respsAng = [];
                  for (let i = 0; i < this.sizeItem; i++) {
                    this.respsAng.push('O');
                    this.gridAnswerChain[i] = 'O';
                  }
                }
              )
            } else {
              this.sizeItem = this._itemControlService.item.itemChild;
              this._answerController.itemId = this._itemControlService.item.itemId;
              this._answerController.itemOrder = 1;
              this._answerController.itemType = this._itemControlService.item.type;
              this.respsAng = [];
              for (let i = 0; i < this.sizeItem; i++) {
                this.respsAng.push('O');
                this.gridAnswerChain[i] = 'O';
              }
            }
            let rtaSelect = "";
            for (let value of this.gridAnswerChain) {
              rtaSelect += value;
              rtaSelect += '|';
            }
            this._answerController.listenFromGrid(rtaSelect.substring(0, rtaSelect.lastIndexOf('|')));
          }
        } else if (this._answerController.itemType == 'open' || this._answerController.itemType == 'open_insor') {
          let self = this;
          if (_answerController.respuesta == null || _answerController.respuesta == "") {
            _answerController.respuesta = "O";
          }
          if (this._answerController.testChrono) {
            clearInterval(this._answerController.testChrono)
          }
          //establecer el tiempo de autoguardado de la respuesta en una prueba con pregunta abierta
          const autoSavePreguntaAbierta = this._configurationControlService.examConfiguration.autoSavePreguntaAbierta;
          this._answerController.testChrono = window.setInterval(() => {
            self.Autosaved();
          }, autoSavePreguntaAbierta)

        } else if (this._answerController.itemType == 'open_file') {

          // codigo eliza
          const file = this._answerController.getFile(this._tokenController.token.credentialId
            , this._answerController.itemId, _answerController.sesion)
          if (file && file.name) {
            setTimeout(function () {
              $('[type="file"]').parent().parent().find('.form-control').html(file.name);
            }, 500);

          }

          // codigo david
          const fileName = `Instruccion_${itemNumero}.pdf`;
          const directory = `${itemNumero}`;

          const pdfButtonHtml = '<div class="pdf-icon"></div>';

          window.setTimeout(() => {
            const div = $("#editor").find(".form-group");
            div.prepend(pdfButtonHtml);

            $(".pdf-icon").bind('click', (event) => {

              _parent.downloadPdf(directory, fileName);

            }).bind(this);
          }, 500);
        }
        else {
          if (_answerController.respuesta == null || _answerController.respuesta == "") {
            _answerController.respuesta = "O";
          }
          this.respAng = _answerController.respuesta;
        }
      }

      ngAfterViewInit(): void {
        !this._welcomeDataService.data.discapacidad && this.ocultarBotonSubItemAudio();
      }

      ocultarBotonSubItemAudio() {
        $(".btnReloadAudioGeneral").attr("style", "display:none !important");
        $(".btnReloadAudio").attr("style", "display:none !important");
      }

      mostrarBotonSubItemAudio() {
        $(".btnReloadAudioGeneral").attr("style", "display:inline !important");
        $(".btnReloadAudio").attr("style", "display:inline !important");
      }

      public updateCharCount(event: any): void {
        const textarea = event.target;
        const currentLength = textarea.value.length;
        const maxLength = 2000;
        const minLength = 200;

        // Actualizar el contador visual
        const charCountElement = document.getElementById('charCount');
        const charCountContainer = document.getElementById('charCountContainer');
        if (charCountElement) {
          charCountElement.textContent = currentLength.toString();

          // ✅ Cambiar color dinámicamente según el número de caracteres
          const parent = charCountElement.parentElement;
          if (charCountContainer) {
            charCountContainer.classList.remove('text-muted', 'text-warning', 'text-danger', 'text-success');

            if (currentLength >= maxLength) {
              charCountContainer.classList.add('text-danger');
            } else if (currentLength >= maxLength * 0.9) {
              charCountContainer.classList.add('text-warning');
            } else if (currentLength >= minLength) {
              // ✅ Verde cuando supera el mínimo requerido
              charCountContainer.classList.add('text-success');
            } else {
              // ✅ Gris/Naranja cuando está por debajo del mínimo
              charCountContainer.classList.add('text-warning');
            }
          }
        }

        // Si excede el límite (por si acaso), truncar
        if (currentLength > maxLength) {
          textarea.value = textarea.value.substring(0, maxLength);
          this._answerController.open = textarea.value;
        }
      }

      /*control de respuestas para preguntas de opcion
      multiple con unica respuesta*/
      public answer(value: any) {
        this._answerController.listenAnswerFromChild(value);
      }

      public validarTamFile(e: any) {
        const limite = this._configurationControlService.tamFile * 1024
        const fileSize: Number = parseInt($(e.target)[0].files[0].size) / 1024

        if (this.validFileExten($(e.target)) == false) {
          $('#validacionExtension').modal({ show: 'true' });

          return false
        }

        if (fileSize.valueOf() > limite) {
          $('#limiArchivoRespuesta').modal({ show: 'true' });
          return false;
        }
        this._answerController.inputFileTempoAnswer = e.target
        const file = this._answerController.getFile(this._tokenController.token.credentialId,
          this._answerController.itemId,
          this._answerController.sesion)

        if (file == null) {
          this._answerService.saveFileAnswer()
        }
        else {
          $('#modificarArchivoRespuesta').modal({ show: 'true' });
        }
      }


      private validFileExten($fileInput: any): boolean {
        let extenIsValid = true
        const accept = $fileInput.attr("accept")
        const listExtens = accept.split(",").filter(ex => ex != "").map(it => { return it.replace(".", "").toLocaleLowerCase() }
        )
        this._answerController.acceptExtenFileAnswer = listExtens.join(" ,")
        const splitFileName = $fileInput.val().split(".")
        if (listExtens.length > 0) {
          let fileExten = null;
          if (splitFileName.length > 0) {
            fileExten = splitFileName[splitFileName.length - 1].toLocaleLowerCase()
          }
          extenIsValid = listExtens.includes(fileExten)
        }

        return extenIsValid
      }

      public prevNowPlaying: any;


      private udpdateOpenAnswerAutoSaved(answer: Answer, callback: (res: any, answer: Answer) => any) {
        this._restService.updateAnswer(this._tokenController.token.token, answer, this._tokenController.token.tokenId).then((res: any) => {
          const synchronized = res == CodResp[0].codigo ? 'S' : 'N';
          this._answerService.updateLocalAnswer(answer, synchronized);
          this._answerController.auxOpenAnswer = this._answerController.open;

          callback(res, answer)
        });

      }

      /*Permite guardar parcialmente respuestas de tipo abierto, sobre un mismo registro en el servidor*/
      public Autosaved() {

        if (this._configurationControlService.examConfiguration.chrono
          && !this._stateService.endTime) {
          let timeChrono = new TimeChrono(this._tokenController.token.credentialId, JSON.stringify(this._stateService.timeChrono), new Date(), this._stateService.state.sesion);
          this._restService.saveTestChrono(this._tokenController.token.token, timeChrono, this._tokenController.token.tokenId);
        }


        if (this._answerController.itemType == 'open' || this._answerController.itemType == 'open_insor') {
          const answerValue = this._answerController.getRespuesta();

          if (this._answerController.open == null || this._answerController.open == ""
            || this._answerController.open == this._answerController.previousAnswer
            || this._answerController.auxOpenAnswer == this._answerController.open) {
            return;
          }

          // ✅ VALIDAR LÍMITE DE 2000 CARACTERES ANTES DE GUARDAR
          let openAnswer = this._answerController.open || '';
          if (openAnswer.length > 2000) {
            console.warn('⚠️ Respuesta excede 2000 caracteres, truncando...');
            openAnswer = openAnswer.substring(0, 2000);
            this._answerController.open = openAnswer;
          }

          const answer = new Answer(this._tokenController.token.credentialId,
            this._answerController.itemId, this._dateServerService.getDateServer(),
            answerValue, 'N',
            this._answerController.sesion, this._answerController.itemOrder,
            this._answerController.publicIp, this._answerController.open,
            this._answerController.marcarRespuesta);
          this.udpdateOpenAnswerAutoSaved(answer, (res: any, answer: Answer) => {
            let isToken = this._tokenController.token.tokenId;

            if (res == CodResp[26].codigo) {
              $('#finishUsuarioModal').modal({
                show: 'true'
              });
            }
          })
        }
      }

      /*constrol de respuestas para preguntas de tipo grilla */
      public gridAnswer(value: any) {
        this._itemControlService.procesandoGuardado = true;
        try {
          let controlValues = value.target.id.split('_');
          let answerPosition = (controlValues[2] - 1);
          if (this.respsAng == null || this.respsAng == undefined || this.respsAng.length == 0) {
            this.respsAng = [];
            this.gridAnswers = [];
            for (let i = 0; i < controlValues[1]; i++) {
              this.respsAng[i] = 'O';
              this.gridAnswers[i] = new Answer(0, 0, this._dateServerService.getDateServer(), '', 'N', 0, 0, '', '', 0);
            }
          }
          let index = -1;
          let answerValue = value.target.value;
          let answer = new Answer(this._tokenController.token.credentialId,
            this._answerController.itemId, this._dateServerService.getDateServer(), answerValue, 'N',
            this._answerController.sesion, this._answerController.itemOrder,
            this._answerController.publicIp, this._answerController.respuestaAbierta,
            this._answerController.marcarRespuesta);
          for (let ans of this.gridAnswers) {
            if (ans && answerValue.split('*')[0] == ans.valorRespuesta.split('*')[0]) {
              index = this.gridAnswers.indexOf(ans);
            }
          }
          if (index == -1) {
            this.respsAng[answerPosition] = answerValue;
            this.gridAnswers[answerPosition] = answer;
          } else {
            this.respsAng[index] = answerValue;
            this.gridAnswers[index] = answer;
          }
          this.buildGridAnswer(answerValue, answerPosition, controlValues[1]);
        } catch (e) {
          console.error(e);
        }
        this._itemControlService.procesandoGuardado = false;
      }

      /*Construye la cadena de rerspuestas de preguntas tipo grilla
      teniendo en cuemnta las omisiones*/
      private buildGridAnswer(value: string, position: number, total: number) {
        if (this.gridAnswerChain == null || this.gridAnswerChain == undefined || this.gridAnswerChain.length == 0) {
          this.gridAnswerChain = [];
          for (let i = 0; i < total; i++) {
            this.gridAnswerChain[i] = 'O';
          }
        }
        this.gridAnswerChain[position] = value;
        let chain = '';
        for (let value of this.gridAnswerChain) {
          chain += value;
          chain += '|';
        }
        this._answerController.listenFromGrid(chain.substring(0, chain.lastIndexOf('|')));
      }

      /*Evento asociado a la selección de respuestas en los items de tipo P2 y P4 */
      public selectAnswer(value: any) {
        this._itemControlService.procesandoGuardado = true;
        try {
          let controlValues = value.target.id.split('_');
          let answerPosition = (controlValues[1] - 1);
          if (this.respsAng == null || this.respsAng == undefined || this.respsAng.length == 0) {
            this.respsAng = [];
            this.gridAnswers = [];
          }
          let replaced = false;
          let index = -1;
          let answerValue = value.target.value;
          let answer;
          if (answerValue != null && answerValue != undefined && answerValue.length != 0 && answerValue != "") {
            answer = new Answer(this._tokenController.token.credentialId,
              this._answerController.itemId, this._dateServerService.getDateServer(), answerValue, 'N',
              this._answerController.sesion, this._answerController.itemOrder,
              this._answerController.publicIp, this._answerController.respuestaAbierta,
              this._answerController.marcarRespuesta);

            if (index != -1) {
              this.respsAng[index] = answerValue;
              this.gridAnswers[index] = answer;
            }
            this.buildSelectAnswer(answerValue, answerPosition, this.gridAnswer.length);
          }
        } catch (e) {
          console.error(e);
        }

        this._itemControlService.procesandoGuardado = false;
      }

      /*Construcción de la cadena de respuestas para los items de tipo P2 y P4;
      separación por | */
      private buildSelectAnswer(value: string, position: number, total: number) {

        this.gridAnswerChain[position] = value;
        let chain = '';
        for (let value of this.gridAnswerChain) {
          chain += value;
          chain += '|';
        }
        this._answerController.listenFromGrid(chain.substring(0, chain.lastIndexOf('|')));
      }

      //Se encarga del cargue de los videos
      public loadAnotherVideo(url: any) {
        url = this.rutaBase + url;
        var video = document.getElementsByTagName('video')[0];
        var sources = video.getElementsByTagName('source');
        sources[0].src = url;
        video.load();
        video.play();
      }
    }

    @NgModule({
      declarations: [TemplateComponent], imports: [FormsModule, ReactiveFormsModule, CKEditorModule]
    })

    class TemplateModule {

    }
    const mod = this._compiler.compileModuleAndAllComponentsSync(TemplateModule);
    const factory = mod.componentFactories.find((comp) =>
      comp.componentType === TemplateComponent
    );
    const component = container.createComponent(factory);
    MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
    MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
    if (this._configurationControlService.examConfiguration.zoomImage) {
      this.loadZoomImage();
    }

    return template
  }

  public async getIncrementoZoom(widthImage: number, heightImage: number, decremento: number, target: any) {
    decremento = decremento + 100;
    var tasaIncremento: number = (window.screen.height - decremento) / heightImage;
    if (widthImage * tasaIncremento > (window.screen.width - decremento)) {
      tasaIncremento = (window.screen.width - decremento) / widthImage;
      if (tasaIncremento * heightImage > (window.screen.height - decremento)) {
        return await this.getIncrementoZoom(widthImage, heightImage, decremento, target);
      }
    }
    $("#imgzoom")[0].width = target.width * tasaIncremento;
    $("#imgzoom")[0].height = target.height * tasaIncremento;

    return tasaIncremento;
  }

  private loadZoomImage() {
    $(".container img").addClass("zoom-in");
    $(".container img").bind('click', (event) => {
      $("#modalzoom").addClass("isOpenZoom");
      $("#imgzoom").attr("src", event.target.src);
      this.getIncrementoZoom(parseInt(event.target.width), parseInt(event.target.height), 5, event.target);
    }).bind(this);
  }

  /** Encargado de aplicar el contraste si existe */
  public loadContrast() {
    $(".audioGeneral").attr("style", "display: block;");
    if (this.contrast) {
      this.highContrast();
    } else {
      this.lowContrast();
    }
  }

  /** Encargado de disminuir el contraste */
  public lowContrast() {
    let self = this;
    $(document).ready(function () {
      $('#contenido .table').attr("class", "table table-sm table-striped table-bordered table-responsive");
      $('#superBody').attr("style", "background-color: white !important; color: black; background-image:url(" + self._welcomeDataService.waterMark + ") !important;background-repeat:repeat")
      $(".modal").css({ "color": "black" });
      $(".modal fade").css({ "color": "black" });
      $("h3").css("color", "#000");
      $("#aumento").removeAttr('style');
      $("#reduce").removeAttr('style');
      $("#btnMarkItem").removeAttr('style');
      $("#high_contrast_on").css("background-color", "transparent");
    })
  }

  /** Encargado de aumentar el contraste */
  public highContrast() {
    $(document).ready(function () {
      $('#contenido .table').attr("class", "table table-sm table-bordered table-responsive");
      $('#superBody').attr("style", "background-color: black !important; color: white;");
      $(".modal").css({ "color": "black" });
      $(".modal fade").css({ "color": "black" });
      $("h3").css("color", "yellow");
      $("#aumento").css("background-color", "#b1ec70");
      $("#reduce").css("background-color", "#b1ec70");
      $("#btnMarkItem").css("background-color", "#b1ec70");
      $("#high_contrast_on").css("background-color", "#b1ec70");
    })
  }
}
